module.exports = __webpack_public_path__ + "static/media/9.adeb5b87.png";